export const BACKORDERS_OPTIONS_REDUCER_NAME = 'backorders-options';

export const backordersOptionsReducer = (state = {}) => state;

export const getBackordersOptions = (state) => state[BACKORDERS_OPTIONS_REDUCER_NAME];
